import React from 'react';
import PropTypes from 'prop-types';
import {getSizeLabelComponent} from './size_label/get_size_label_component';
import {getSizeValueComponent} from './size_value/get_size_value_component';

class SizeComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {status, filters, onClick} = this.props;

        return (
            <div className="statusbar-mobile-current-status__slider-wrapper swiper-wrapper">
                <div
                    className="statusbar-mobile-current-status__size-section statusbar-mobile-current-status__slider-slide swiper-slide"
                    onClick={onClick}
                >
                    {getSizeLabelComponent(status)}
                    {getSizeValueComponent(status, filters, this.props.displayDimensions)}
                </div>
            </div>
        );
    }
}

SizeComponent.propTypes = {
    status: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    displayDimensions: PropTypes.string,
};

SizeComponent.defaultProps = {
    displayDimensions: '',
}

export {SizeComponent};
